export const WINDOW_MEDIUM = 2170;
export const WINDOW_SMALL = 1920;
export const WINDOW_EXTRA_SMALL = 1600;
